module.exports = __webpack_public_path__ + "img/hibernate.6b6d3027.svg";